import React from 'react'; // eslint-disable-line

class OnOffSwitch extends React.Component {
    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.handleClick = this.handleClick.bind(this);
    }

    handleChange(e) {
        this.props.onChange(this.props.name, e.target.checked);
    }

    handleClick(e) {
        this.props.onChange(this.props.name, !e.currentTarget.querySelector("input").checked);
    }

    render() {
        return (
            // eslint-disable-next-line
            <div className={`module__toggle ${this.props.buttonClass ? this.props.buttonClass : ""} ${!!this.props.isToggleOn ? " checked" : ""}`} onClick={this.handleClick} data-testid={this.props.dataTestid}>
                <div className="toggle checkbox">
                    <input
                        id={this.props.id}
                        type="checkbox"
                        onChange={this.handleChange}
                        name={this.props.name}
                        defaultValue={!!this.props.isToggleOn}
                        checked={!!this.props.isToggleOn}
                        disabled={this.props.disabled}
                        data-testid={this.props.dataTestid+"_input"}
                        style={this.props.disabled ? { pointerEvents: 'none' } : {}}
                    />
                    <label><span /></label>
                </div>
            </div>
        );
    }
}
export default OnOffSwitch;
